import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/fastpeps-core-storefront/src/modules/common/components/localized-client-link/index.tsx");
